module.exports = __webpack_public_path__ + "img/xiaoman1.9146c1ba.png";